import MainLayout from '../layouts/main';
import TopScoresContainer from './container';

function TopStudentScoresPage() {
  return (
    <MainLayout>
      <TopScoresContainer />
    </MainLayout>
  );
}

export default TopStudentScoresPage;
